import { Injectable } from '@angular/core';
import { RouterStateSnapshot, CanActivate, ActivatedRouteSnapshot } from '@angular/router';
import { AuthService } from './auth.service';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';

@Injectable()
export class RoleGuardService implements CanActivate {
  constructor(
    private _authService: AuthService,
    private _toastrService: ToastrService,
    private _translateService: TranslateService
    ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
      const expectedRole = route.data.expectedRole;
      const forbiddenRole = route.data.forbiddenRole;

      if (expectedRole.length > 0) {
        for (const role of expectedRole) {
          if (this._authService.hasRole(role)) {
              return true;
          }
        }
      }

      if (forbiddenRole.length > 0) {
        for (const role of forbiddenRole) {
          if (this._authService.hasRole(role)) {
              return false;
          }
        }
      }

      if (expectedRole.length === 0) {
          return true;
      }

      this._translateService.get('Messages.NoPermission').subscribe(translated => {
        this._toastrService.warning(translated);
      });
      return false;
  }
}



// WEBPACK FOOTER //
// C:/TeamCity/BuildAgent3/work/c38c6eefb6a115e8/HSG.Accounting/HSG.Accounting.MonitoringMobileApp/src/app/auth/role-guard.service.ts